import { render, staticRenderFns } from "./teaUseProduct.vue?vue&type=template&id=d2593162&scoped=true"
import script from "./teaUseProduct.vue?vue&type=script&lang=js"
export * from "./teaUseProduct.vue?vue&type=script&lang=js"
import style0 from "./teaUseProduct.vue?vue&type=style&index=0&id=d2593162&prod&lang=scss&scoped=true"
import style1 from "./teaUseProduct.vue?vue&type=style&index=1&id=d2593162&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2593162",
  null
  
)

export default component.exports